// src/pages/UserBalance.js
import React from 'react';

const UserBalance = () => {
  return (
    <div>
      <h1>Пополнить баланс пользователя</h1>
      <p>This page will be used to top up a user's balance.</p>
    </div>
  );
};

export default UserBalance;
